import React from "react";

import "./style.css";

const HexLocationButton = ({ onLocate }) => {
  const getLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      onLocate(position);
    });
  };

  return (
    <img
      src={"/assets/icons/map/current-location.png"}
      className="location-icon"
      aria-hidden="true"
      title="Find my location"
      alt="current-location"
      onClick={getLocation}
    />
  );
};

export default HexLocationButton;
